import Swal from 'sweetalert2';

function alertWarning(config: {title: string; text?: string; button: string}, callback: () => void): boolean {
  if (!config) return false;

  Swal.fire({
    title: config.title,
    text: config.text,
    icon: 'question',
    confirmButtonText: config.button || '确 认',
    showCancelButton: true,
    cancelButtonText: '取 消',
    customClass: {
      confirmButton: 'el-button el-button--primary',
      cancelButton: 'el-button el-button--default',
    },
    // buttons: {
    //   confirm: config.button || '确 认',
    //   cancel: '取 消',
    // },
    buttonsStyling: false,
  }).then((result) => {
    if (result.isConfirmed && callback) {
      callback();
    }
  });

  return false;
}

export default alertWarning;
